<script>
  import { blogs, blogsUpdated } from "../../constants";
  import { page } from "$app/stores";
  import AnchorsList from "$lib/AnchorsList.svelte";
  import Frame from "$lib/Frame.svelte";

  $: slug = $page.params.slug;
  $: blog = blogs.find((blog) => blog.slug === slug);
</script>

<div class="flex flex-row <sm:flex-col-reverse <sm:text-sm absolute h-full w-full overflow-hidden">
  <aside class="flex flex-col w-full sm:(w-lg max-w-30%) p-10">
    <AnchorsList list={blogs} item={blog} />
    <span class="bottom-10 flex-grow font-bold text-xs mt-8 flex flex-col justify-end">最后更新于 {blogsUpdated}</span>
  </aside>
  <main class="h-full <sm:h-100vh w-full"><Frame obj={blog} /></main>
</div>
